export interface SettingsDotJson {
  demoModeEmailAddress: string
  demoModeEnabled: boolean
  marketsWithFactoryModelsShowAllStartMode: number[]
  oneTrustEnabled: boolean
  interiorPanoramaEnabled: boolean
}

// TODO: Move to a more appropriate source file.
export async function fetchSettings(): Promise<SettingsDotJson> {
  const settingsResponse = await fetch('/settings.json')
  const settingsDynamic = await settingsResponse.json()
  const emailDynamic = settingsDynamic['demoModeEmailAddress']
  const demoModeEmailAddress: string =
    typeof emailDynamic === 'string' ? emailDynamic : ''
  const validEmailFormat =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i
  const demoModeEnabled: boolean = validEmailFormat.test(demoModeEmailAddress)
  let oneTrustEnabled = getBooleanSetting(
    settingsDynamic,
    'oneTrustEnabled',
    false,
  )
  if (!oneTrustEnabled) {
    console.log('One trust is not enabled.')
  }
  const maybeMarketIdArray =
    settingsDynamic['marketsWithFactoryModelsShowAllStartMode']
  if (!Array.isArray(maybeMarketIdArray)) {
    throw new Error(
      'Expected marketsWithFactoryModelsShowAllStartMode to be an array',
    )
  }
  const marketsWithFactoryModelsShowAllStartMode = []
  for (const marketId of maybeMarketIdArray) {
    if (typeof marketId !== 'number') {
      throw new Error(
        'Expected marketsWithFactoryModelsShowAllStartMode to only contain numbers, found: ' +
          marketId,
      )
    }
    marketsWithFactoryModelsShowAllStartMode.push(marketId)
  }
  let interiorPanoramaEnabled = getBooleanSetting(
    settingsDynamic,
    'interiorPanoramaEnabled',
    true,
  )
  return {
    demoModeEmailAddress,
    demoModeEnabled,
    marketsWithFactoryModelsShowAllStartMode,
    oneTrustEnabled,
    interiorPanoramaEnabled,
  }
}
function getBooleanSetting(
  settingsDynamic: any,
  key: string,
  default_: boolean,
): boolean {
  let val = settingsDynamic[key]
  if (typeof val === 'string') {
    if ((val as string).startsWith('#{')) {
      return default_
    }
    return val === 'true'
  }
  if (typeof val === 'boolean') {
    return val
  }
  throw new Error('Unexpected settings value: ' + val + ', for key: ' + key)
}
